import diContainer from '../utilities/js/diContainer/diContainer';
const isTestEnv = location.href.indexOf('env=test') > -1;
diContainer.add({
  env: isTestEnv ? 'test' : ''
});
